import { createAsyncThunk } from '@reduxjs/toolkit';
import { CompanyLine } from 'model/CompanyLine';
import { createApiService } from 'service';

export enum ActionTypes {
    GET_ALL_COMPANY_LINE = 'getAllCompanyLine'
}

export const createCompanyLineService = () => {
    const apiService = createApiService();
    return {
        getCompanyLines: (): Promise<CompanyLine[]> => {
            return apiService.get('companyLine/all?ExcludeInternalLines=true');
        }
    }
}

export const createCompanyLineAction = () => {
    const service = createCompanyLineService();

    const getCompanyLines = createAsyncThunk<CompanyLine[]>(ActionTypes.GET_ALL_COMPANY_LINE,
        (_, thunkApi) => service.getCompanyLines().catch((error) => thunkApi.rejectWithValue(error))
    );

    return { getCompanyLines };
}
